import React from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Paper,
  styled
} from '@mui/material';
import { SentimentDissatisfied as SadIcon } from '@mui/icons-material';

const NotFoundContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(6),
  marginTop: theme.spacing(8),
  marginBottom: theme.spacing(4),
  borderRadius: '16px',
  textAlign: 'center',
  maxWidth: '600px',
  margin: '0 auto',
  boxShadow: '0 8px 40px rgba(0, 0, 0, 0.12)'
}));

const NotFound = () => {
  return (
    <Container maxWidth="md" sx={{ pt: 10, pb: 6 }}>
      <NotFoundContainer elevation={3}>
        <SadIcon sx={{ fontSize: 80, color: 'primary.main', mb: 2, opacity: 0.7 }} />
        
        <Typography variant="h3" component="h1" gutterBottom>
          404 - Page Not Found
        </Typography>
        
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          The page you are looking for doesn't exist or has been moved.
        </Typography>
        
        <Box sx={{ mt: 4 }}>
          <Button
            component={Link}
            to="/"
            variant="contained"
            color="primary"
            size="large"
          >
            Return to Home
          </Button>
        </Box>
      </NotFoundContainer>
    </Container>
  );
};

export default NotFound;
